export const BILLING_ERROR_CODES = new Set([
  "FREE_TIER_LIMIT_EXCEEDED",
  "PREMIUM_TIER_LIMIT_EXCEEDED",
  "SUBSCRIPTION_REQUIRED",
  "PLAN_LIMIT_REACHED",
]);

type SubscriptionLike = {
  isPremium?: boolean | null;
  hasSubscriptionHistory?: boolean | null;
  gracePeriodEndsAt?: number | null;
} | null | undefined;

export function isInGracePeriod(subscription: SubscriptionLike) {
  return typeof subscription?.gracePeriodEndsAt === "number"
    && subscription.gracePeriodEndsAt > Date.now();
}

export function shouldShowLoggedRenewal(subscription: SubscriptionLike) {
  return Boolean(
    subscription?.hasSubscriptionHistory
      && !subscription.isPremium
      && !isInGracePeriod(subscription),
  );
}

export function buildLoggedBillingPath(options: { handle?: string; reason?: string } = {}) {
  const params = new URLSearchParams();
  if (options.handle) params.set("handle", options.handle);
  if (options.reason) params.set("reason", options.reason);
  const query = params.toString();
  return query ? `/app/renew?${query}` : "/app/renew";
}
